import React from "react";
import { FormComponent } from "../../../../../../../../../react-core/Html/FormComponent";
import { AccountDetails } from "./AccountDetails";
import { ClientAccess } from "./ClientAccess";
import { PaperlessPerference } from "./PaperlessPerference";
import { ReportOptOut } from "./ReportOptOut";

interface IAccountInformationProps {
    selectedAccount: any;
    customerId: number;
}

interface IAccountInformationState {}

export class AccountInformation extends FormComponent<IAccountInformationProps, IAccountInformationState> {
    constructor(props: IAccountInformationProps) {
        super(props);
        this.state = {};
    }

    render() {
        return (
            <>
                <AccountDetails
                    accountHierarchyId={this.props.selectedAccount.hierarchyId}
                    customerId={this.props.customerId}
                />
                <PaperlessPerference
                    accountHierarchyId={this.props.selectedAccount.hierarchyId}
                    customerId={this.props.customerId}
                />
                <ReportOptOut clAccountId={this.props.selectedAccount.id} />
                <hr />
                <h3>
                    <b className="mb-10">Customer's information - {this.props.selectedAccount?.customerName}</b>
                </h3>

                <ClientAccess
                    customerId={this.props.customerId}
                    hierarchyId={this.props.selectedAccount.hierarchyId}
                    clAccountId={this.props.selectedAccount.id}
                    roleType={this.props.selectedAccount.roleTypeId}
                />
            </>
        );
    }
}
